module.exports = __webpack_public_path__ + "img/scale.d0e7be13.svg";